import { render, staticRenderFns } from "./search.vue?vue&type=template&id=0131a77c&"
import script from "./search.js?vue&type=script&lang=js&"
export * from "./search.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports